import { APP_CONFIG } from '@config/api.config'
import './Footer.scss'

export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="crif-footer">
      <div className="crif-footer-content">
        <div className="crif-footer-left">
          <p className="mb-0">
            &copy; {currentYear} CRIF. All rights reserved.
          </p>
        </div>

        <div className="crif-footer-center">
          <span className="badge bg-secondary">
            {APP_CONFIG.name} v{APP_CONFIG.version}
          </span>
        </div>

        <div className="crif-footer-right">
          <a href="/privacy" className="crif-footer-link">
            Privacy Policy
          </a>
          <span className="crif-footer-divider">|</span>
          <a href="/terms" className="crif-footer-link">
            Terms of Service
          </a>
          <span className="crif-footer-divider">|</span>
          <a href="/support" className="crif-footer-link">
            Support
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
